import React, { createContext, useContext, useState } from "react";
import { API_ENDPOINT, APP_ID } from "../utils/constants";
import ImageCropperModal from "../widgets/ImageCropperModal";
import { getToken } from "../utils/utils2";
const ImageUploadContext = createContext();
export const useImageUpload = () => useContext(ImageUploadContext);
export const ImageUploadProvider = ({ children }) => {
  const [modalState, setModalState] = useState({
    open: false,
    type: "",
    aspectRatio: 1,
    onSuccess: null,
    onError: null,
    customUrl: null, // Allows overriding the URL for specific edge cases
  });

  const openCropper = ({
    type,
    aspectRatio,
    onSuccess,
    onError,
    customUrl,
  }) => {
    setModalState({
      open: true,
      type,
      aspectRatio,
      onSuccess,
      onError,
      customUrl,
    });
  };

  const closeCropper = () => {
    setModalState((prev) => ({ ...prev, open: false }));
  };

  // Standardize your URL and Auth here
  const defaultUploadUrl = `${API_ENDPOINT}/event/upload-image-event-settings-main-2/${modalState.type}`;
  const uploadUrl = modalState.customUrl || defaultUploadUrl;
  const headers = { token: getToken() };

  return (
    <ImageUploadContext.Provider value={{ openCropper, closeCropper }}>
      {children}
      <ImageCropperModal
        open={modalState.open}
        onClose={closeCropper}
        aspectRatio={modalState.aspectRatio}
        maxSizeKB={1024}
        uploadUrl={uploadUrl}
        headers={headers}
        onSuccess={(response) => {
          if (modalState.onSuccess) modalState.onSuccess(response);
          closeCropper(); // Auto-close on success
        }}
        onError={(error) => {
          if (modalState.onError) modalState.onError(error);
        }}
      />
    </ImageUploadContext.Provider>
  );
};
